"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _Group = /*#__PURE__*/ _interop_require_default(require("./Group"));
var _Term = /*#__PURE__*/ _interop_require_default(require("./Term"));
var _Description = /*#__PURE__*/ _interop_require_default(require("./Description"));
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
var _descriptionListmodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/descriptionList.module.css"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var DescriptionList = function(param) {
    var children = param.children, dataTestId = param["data-testid"], className = param.className;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)("dl", {
        "data-testid": dataTestId,
        className: (0, _clsx.default)([
            _descriptionListmodulecss.default.listContainer,
            className
        ]),
        children: children
    });
};
DescriptionList.Group = _Group.default;
DescriptionList.Term = _Term.default;
DescriptionList.Description = _Description.default;
var _default = DescriptionList;
